<template>
  <header
    id="header"
    class="d-flex align-items-center shadow-sm bg-primary fixed-top main-header"
  >
    <div class="main-header__container">
      <a class="main-header__logo" :href="METIME_URL">
        <img src="../assets/images/logo-white.png" alt="MeTime Logo" />
      </a>

      <div class="main-header__navigation-wrapper">
        <nav
          class="main-header__navigation"
          :class="{
            'main-header__navigation--mobile':
              vssWidth < LAYOUT_BREAKPOINTS.XLARGE,
            'main-header__navigation--mobile--open': isMobileOpen,
          }"
        >
          <a :href="METIME_URL" class="main-header__navigation__item">Home</a>

          <router-link
            :to="SIGN_UP_ROUTE.path"
            class="main-header__navigation__item"
          >
            Register
          </router-link>

          <a
            :href="METIME_URL + 'providers'"
            class="main-header__navigation__item"
          >
            Find a Provider
          </a>

          <a
            :href="METIME_URL + 'articles'"
            class="main-header__navigation__item"
          >
            Articles
          </a>

          <a
            :href="METIME_URL + 'solutions'"
            class="main-header__navigation__item"
          >
            Solutions
          </a>

          <a :href="METIME_URL + 'blog'" class="main-header__navigation__item">
            Blog
          </a>
        </nav>

        <router-link
          :to="isHomeRoute ? SIGN_UP_ROUTE.path : LOGIN_ROUTE.path"
          class="btn btn-light--v1 button btn__max-width-lg btn-shadow rounded-05 order-2 order-lg-3 main-header__button"
          >{{
            isHomeRoute ? "Provider Sign Up" : "Provider Sign In"
          }}</router-link
        >

        <HamburgerButton
          class="d-xl-none order-4"
          @click="handleHamburgerOnClick"
        />
      </div>
    </div>
  </header>
</template>

<script setup>
import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import { METIME_URL, ROUTES } from "@/const.js";
import HamburgerButton from "./HamburgerButton.vue";
import { LAYOUT_BREAKPOINTS } from "@/const/layoutBreakpoints";
import { useScreenSize } from "@/components/composables/useScreenSize";

const SIGN_UP_ROUTE = ROUTES.get("SIGN_UP");
const LOGIN_ROUTE = ROUTES.get("LOGIN");

const { vssWidth } = useScreenSize();

const route = useRoute();

const isHomeRoute = computed(() => route.fullPath === LOGIN_ROUTE.path);

const isMobileOpen = ref(false);

const handleHamburgerOnClick = () => {
  isMobileOpen.value = !isMobileOpen.value;
};
</script>
